import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {getCities, getProvinces, getUserCities} from "../../actions";
import {withRouter} from "../../../utils/services/with-router";
import {Flex, Input, Select, Skeleton} from "antd";
import LocationHeader from "../../components/location/locationHeader/LocationHeader";
import {LocationFooter} from "../../components/location/LocationFooter";
import {CitiesFilter, LocationProps} from "../../models";
import ProvinceCard from "../../components/location/provinceCard/ProvinceCard";
import CitiesCard from "../../components/location/citiesCard/CitiesCard";
import { SearchOutlined } from '@ant-design/icons';
import AllCitiesCard from "../../components/location/citiesCard/AllCitiesCard";

const Location = ({getProvinces, getCities, getUserCities}: LocationProps) => {
    const [provinceList, setProvinceList] = useState<any[]>([]);
    const [citiesList, setCitiesList] = useState<any[]>([]);
    const [searchText, setSearchText] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [showProvince, setShowProvince] = useState<boolean>(true);
    const [citiesId, setCitiesId] = useState<any[]>([]);

    const getProvinceList = () => {
        setLoading(true)
        getProvinces()
            .then((data: any) => {
                if (data.payload != undefined) {

                    setProvinceList(data.payload.data);

                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => {
            });
    };
    const _getUserCities = () => {
        getUserCities()
            .then((data: any) => {
                if (data.payload != undefined) {

                    setCitiesId(data.payload.data);

                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => {
            });
    };
    const getCitiesList = (provinceId: number) => {
        setLoading(true)
        let model: CitiesFilter = {
            provinceId: provinceId,
            searchText: ""
        }
        getCities(model)
            .then((data: any) => {
                if (data.payload != undefined) {

                    setCitiesList(data.payload.data);
                    setShowProvince(false)
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        getProvinceList()
        _getUserCities()
    }, []);
    const onCityClick = (city: any) => {
        if (city.checked) {
            if (!citiesId.includes(city.item.id)) {
                setCitiesId([...citiesId, city.item]);
            }
        } else {
            if (citiesId.some((i: any) => i.id === city.item.id)) {
                setCitiesId(citiesId.filter((i: any) => i.id !== city.item.id));
            }
        }
    }
    const onAllCityClick = (checked:boolean) => {
        if (checked) setCitiesId(citiesList)
        else setCitiesId([])
    }
    return (
        <Flex vertical gap={"small"}>

            <LocationHeader onDeleteClick={onCityClick} citiesTag={citiesId}
                            onBackBtn={(i: boolean) => {
                                setSearchText("")
                                setShowProvince(i)

                            }} showProvince={showProvince}/>

            <Input addonAfter={<SearchOutlined />} size={"large"} placeholder={showProvince ?'جستجو استان' : 'جستجو شهر'} value={searchText}
                   onChange={(e) => {
                       setSearchText(e.target.value)
            }}></Input>
            {loading ? <Flex vertical>
                    <Skeleton round active/>
                    <Skeleton round active/>
                    <Skeleton round active/>
                </Flex> :
                showProvince ? provinceList.filter((i: any) => i.name?.toLowerCase().includes(searchText?.toLowerCase())).map((item: any) =>
                        <ProvinceCard id={item.id} title={item.name} onCategoryClick={(id: number) => {
                            getCitiesList(id)
                            setSearchText("")
                        }}/>
                    )
                    : <Flex vertical gap={"small"}>
                        <AllCitiesCard citiesList={citiesList} citiesId={citiesId} title={'همه'}
                                    onCityClick={(arg: any) => {
                                        onAllCityClick(arg)

                                    }}/>
                        {citiesList.filter((i: any) => i.name?.toLowerCase().includes(searchText?.toLowerCase())).map((item: any) =>
                            <CitiesCard item={item} citiesId={citiesId} id={item.id} title={item.name}
                                        onCityClick={(arg: any) => {
                                            onCityClick(arg)

                                        }}/>
                        )}
                    </Flex>

            }

            <LocationFooter cities={citiesId}/>
        </Flex>
    );
};

export default connect(null, {getProvinces, getCities, getUserCities})(withRouter(Location));
